<template>
  <div class="ErrorList">
    <el-dialog
        :title="isEdit ? $t('update' || '修改') : $t('add' || '新增')"
        :visible="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="handleClose"
        width="580px"
        center
    >
      <div>
        <el-form
          :model="ruleForm"
          :rules="activeRules"
          ref="ruleForm"
          label-width="auto"
          label-suffix=":"
          class="demo-ruleForm"
        >
          <el-form-item :label="$t('amazon.amazon02' || '店铺名称')" v-bind="isEdit ? {} : { prop: 'shopName' }">
            <el-input size="small" v-model="ruleForm.shopName" :disabled="isEdit"></el-input>
          </el-form-item>
          <el-form-item :label="$t('amazon.amazon03' || '卖家编号')" v-bind="isEdit ? {} : { prop: 'sellingPartnerId' }">
            <el-input size="small" v-model="ruleForm.sellingPartnerId" :disabled="isEdit"></el-input>
          </el-form-item>
          <el-form-item :label="$t('amazon.amazon04' || '应用ID')" v-bind="isEdit ? {} : { prop: 'applicationId' }">
            <el-input size="small" v-model="ruleForm.applicationId" :disabled="isEdit"></el-input>
          </el-form-item>
          <el-form-item :label="$t('amazon.amazon05' || '客户端令牌')" prop="lwaRefreshToken">
            <el-input size="small" v-model="ruleForm.lwaRefreshToken"></el-input>
          </el-form-item>
          <el-form-item :label="$t('amazon.amazon06' || '客户端编码')" v-bind="isEdit ? {} : { prop: 'lwaClientId' }">
            <el-input size="small" v-model="ruleForm.lwaClientId" :disabled="isEdit"></el-input>
          </el-form-item>
          <el-form-item :label="$t('amazon.amazon07' || '客户端密钥')" prop="lwaClientSecret">
            <el-input size="small" v-model="ruleForm.lwaClientSecret"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="" style="display: flex;justify-content: flex-end;">
        <el-button class="form-btn btn-blue" @click="submitForm('ruleForm')">{{ $t('common.confirm' || '确定') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "GoodsItem",
  props: {
    editRow: {
      type: Object,
      default: null
    }
  },
  computed: {
    isEdit () {
      return !!(this.editRow && this.editRow.id != null)
    },
    activeRules () {
      if (this.isEdit) {
        return {
          lwaRefreshToken: this.rules.lwaRefreshToken,
          lwaClientSecret: this.rules.lwaClientSecret
        }
      }
      return this.rules
    }
  },
  data(){
    return {
      ruleForm: {
        shopName: '',
        applicationId: '',
        sellingPartnerId: '',
        lwaClientId: '',
        lwaClientSecret: '',
        lwaRefreshToken: '',
        lwaExpireTime: ''
      },
      rules: {
        shopName: [
          { required: true, message: this.$t('common.pleaseInput') + this.$t('amazon.amazon02' || '店铺名称'), trigger: 'blur' },
        ],
        sellingPartnerId: [
          { required: true, message: this.$t('common.pleaseInput') + this.$t('amazon.amazon03' || '店铺名称'), trigger: 'blur' },
        ],
        applicationId: [
          { required: true, message: this.$t('common.pleaseInput') + this.$t('amazon.amazon04' || '店铺名称'), trigger: 'blur' },
        ],
        lwaRefreshToken: [
          { required: true, message: this.$t('common.pleaseInput') + this.$t('amazon.amazon05' || '店铺名称'), trigger: 'blur' },
        ],
        lwaClientId: [
          { required: true, message: this.$t('common.pleaseInput') + this.$t('amazon.amazon06' || '店铺名称'), trigger: 'blur' },
        ],
        lwaClientSecret: [
          { required: true, message: this.$t('common.pleaseInput') + this.$t('amazon.amazon07' || '店铺名称'), trigger: 'blur' },
        ],

        // lwaExpireTime: [
        //   { required: true, message: this.$t('common.pleaseInput'), trigger: 'blur' },
        // ],
      }
    }
  },
  created () {
    if (this.isEdit && this.editRow) {
      const r = this.editRow
      this.ruleForm = {
        ...this.ruleForm,
        id: r.id,
        shopName: r.shopName || '',
        sellingPartnerId: r.sellingPartnerId || '',
        applicationId: r.applicationId || '',
        lwaClientId: r.lwaClientId || '',
        lwaRefreshToken: r.lwaRefreshToken || '',
        lwaClientSecret: r.lwaClientSecret || ''
      }
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const url = this.isEdit
            ? 'aws/amazonShopRegister/update'
            : 'aws/amazonShopRegister/save'
          const payload = this.isEdit
            ? {
                id: this.editRow.id,
                lwaRefreshToken: this.ruleForm.lwaRefreshToken,
                lwaClientSecret: this.ruleForm.lwaClientSecret
              }
            : this.ruleForm
          this.$http.post(url, payload).then(res => {
            if (res.data.code == 200) {
              this.$message({
                type: "success",
                message: res.data.msg,
              });
              this.$options.confirm(true)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose () {
      this.$options.cancel('cancel')
    }
  }
}
</script>

<style scoped lang="less">
.ErrorList{
  :deep(.el-dialog__body){
    padding: 0 20px;
  }
  :deep(.el-dialog__footer){
    padding: 0 20px 20px;
  }
}

</style>
